import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { HHNTheme } from "hhn-commons";
import { useEffect } from "react";

interface PolylineOverlayProps {
  encodedPath: string;
}

const PolylineOverlay = ({ encodedPath }: PolylineOverlayProps) => {
  const maps = useMapsLibrary("maps");
  const map = useMap();
  const geometryLibrary = useMapsLibrary("geometry");
  useEffect(() => {
    if (!maps || !map || !encodedPath || !geometryLibrary) return;

    const decodedPath = geometryLibrary.encoding.decodePath(encodedPath);
    const routePolyline = new maps.Polyline({
      path: decodedPath,
      strokeColor: HHNTheme.route.line,
      strokeOpacity: 0.8,
      strokeWeight: 6,
    });
    routePolyline.setMap(map);

    // Adjust map bounds to fit the route
    const bounds = new google.maps.LatLngBounds();
    decodedPath.forEach((point: google.maps.LatLng) => bounds.extend(point));
    map.fitBounds(bounds);

    return () => {
      routePolyline.setMap(null);
    };
  }, [maps, map, encodedPath, geometryLibrary]);

  return null;
};

export default PolylineOverlay;
